import { Col, Row } from "antd";
import React from "react";
import OrdersByLocation from "./components/orders-by-location-chart";
import ShopOrders from "./components/shop-orders-chart";
import "../../home.scss";

const HomeCharts: React.FC = () => {
  return (
    <Row gutter={16}>
      <Col md={12} xs={24}>
        <OrdersByLocation />
      </Col>

      <Col md={12} xs={24}>
        <ShopOrders />
      </Col>
    </Row>
  );
};

export default HomeCharts;
